































































import { Component, Watch, Mixins } from 'vue-property-decorator';
import ProgressMixin from '../mixin';
import { required, maxLength } from 'vuelidate/lib/validators';
import { mapItems } from '@/tools/mapitems';
import { FormInput } from '@/pages/profile/blocks';
import { Button } from '@/pages/profile/components';
import { Heading } from '../components';
import store from '@/pages/profile/store';
import { progressStore } from '../ProgressStore';
import { IAddCompetition, CompetitionFormData } from './types';

@Component({
  components: {
    FormInput,
    Heading,
    Button,
  },
  validations: {
    competitionForm: {
      level: { required },
      type: { required },
      name: { required, maxLength: maxLength(100) },
      organizer: { required, maxLength: maxLength(100) },
      link: { required, maxLength: maxLength(100) },
    },
  },
})
export default class AddCompetition extends Mixins(ProgressMixin)
  implements IAddCompetition {
  competitionForm: CompetitionFormData = {
    level: '',
    name: '',
    organizer: '',
    link: '',
    type: '',
  };

  get nokoCompetitionTypes() {
    const { nokoCompetitionTypes } = this.state;
    return mapItems(nokoCompetitionTypes);
  }

  get isDisabled(): boolean {
    const { $v } = this;
    return $v ? $v.$invalid : true;
  }

  @Watch('competitionForm.level')
  onLevelChange(value: string) {
    progressStore.addLevel(value);
  }

  mounted() {
    const { level } = progressStore.state;
    this.competitionForm.level = level;
  }

  beforeDestroy() {
    store.modal = false;
  }

  submitCompetitionForm() {
    const { $v, competitionForm } = this;
    if ($v) {
      $v.$touch();
      if (!$v.$invalid) {
        this.$emit('submitCompetitionForm', { ...competitionForm });
      }
    }
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/profile/views/progress/forms/competitionform/AddCompetition.vue